import { EXO_SKELETON_RUNTIME_SCOPE } from './consts';
import { createUniqueRequestId } from './internal';
export function createRuntimeDataEvent(type, data) {
  return {
    requestId: createUniqueRequestId(type),
    type,
    data,
    eventTimestampUTC: new Date(new Date().toUTCString()).getTime()
  };
}
export function isInExoSkeleton() {
  var _window$EXO_SKELETON_;
  return Boolean((_window$EXO_SKELETON_ = window[EXO_SKELETON_RUNTIME_SCOPE]) === null || _window$EXO_SKELETON_ === void 0 ? void 0 : _window$EXO_SKELETON_.available);
}
export function createPostMessageEventHandler(callback) {
  window.addEventListener('message', callback);
  return {
    dispose() {
      window.removeEventListener('message', callback);
    }
  };
}
export function sendRuntimeDataEvent(type, data) {
  const targetOrigin = window.location.origin;
  const event = createRuntimeDataEvent(type, data);
  return new Promise(resolve => {
    const listenerCallback = _ref => {
      let {
        data: eventData
      } = _ref;
      if (eventData.requestId === event.requestId) {
        resolve(eventData);
        window.removeEventListener('message', listenerCallback);
      }
    };
    window.addEventListener('message', listenerCallback);
    try {
      window.postMessage(event, targetOrigin);
    } catch (e) {
      const originalEventData = event.data;
      event.data = JSON.parse(JSON.stringify(event.data));
      window.postMessage(event, targetOrigin);
      console.error('Failed to send parse "postMessage" data, fallback to "JSON.parse(JSON.stringify(...))"', e, event, originalEventData);
    }
  });
}
//# sourceMappingURL=runtime.js.map